export const reset = action => async dispatch => {
  dispatch({ type: `${action}_RESET` });
};
